<!-- 获取车位信息接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {"parkCode":"2KNTYVWC","pageNumber":"1","pageSize":"1"},
            responseCode: 	{"data":{"carportList":[{"carportAlaisName":"123","carportSerialNumber":"123","carportType":1,"isOpenReserved":true,"openReserved":true,"parkingLotId":"2KNTYVWC"}],"currCount":1,"total":6},"message":"业务成功","resultCode":0,"status":1},
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取车位信息",
                t_url: this.commonUrls.test+"getCarport",
                p_url: this.commonUrls.prod+"getCarport",
                precondition: "VEMS 2.10.5及以上版本",
                fitSystem: "VEMS传统停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'parkingLotId', info2: '否', info3: 'String', info4: '停车场编号' },
                        { info1: 'carportSerialNumber', info2: '否', info3: 'String', info4: '车位编号' },
                        { info1: 'carportAlaisName', info2: '否', info3: 'String', info4: '车位别名' },
                        { info1: 'carportType', info2: '否', info3: 'integer', info4: '车位类型 0未指定,1固定车位,2临时车位,3租用车位' },
                        { info1: 'isOpenReserved', info2: '否', info3: 'integer', info4: '是否开启预订 0否，1是' },
                        { info1: 'pageSize', info2: '是', info3: 'integer', info4: '每页多少条数据最大值为1000' },
                        { info1: 'pageNumber', info2: '是', info3: 'integer', info4: '第几页最小值为1' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'total', info2: '是', info3: 'Integer', info4: '记录总数' },
                        { info1: 'currCount', info2: '是', info3: 'Integer', info4: '当前获取的记录数' },
                        { info1: 'carportList', info2: '是', info3: 'JSONArray', info4: '' }
                        ]
                },{
                    titleName: 'carportList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkingLotId', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'carportSerialNumber', info2: '是', info3: 'String', info4: '车位编号' },
                        { info1: 'carportAlaisName', info2: '是', info3: 'String', info4: '车位别名' },
                        { info1: 'carportType', info2: '是', info3: 'int', info4: '车位类型 0未指定,1固定车位,2临时车位,3租用车位' },
                        { info1: 'isOpenReserved', info2: '是', info3: 'boolean', info4: '是否开启预订 false否，true是' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/yard/getCarport.vue